import { utils } from './utils'

export class SnailyPromise<T = unknown> extends Promise<T> {
	constructor(
		callback: (
			resolve: (value: T | PromiseLike<T>) => void,
			reject: (reason?: unknown) => void
		) => void
	) {
		const temp: { stack?: string } = {}
		Error.captureStackTrace(temp, SnailyPromise)
		const stackTrace = utils.cutFirstLine(temp.stack ?? '')

		const wrappedCallback = function (
			resolve: (value: T | PromiseLike<T>) => void,
			reject: (reason?: unknown) => void
		) {
			try {
				callback(resolve, function (e) {
					if (utils.isJson(e)) {
						if (e.stack) {
							e.stack = `${e.stack}\n${stackTrace}\n`
						} else {
							e.stack = stackTrace
						}
					}
					reject(e)
				})
			} catch (exp) {
				//ToDo;
				throw exp
			}
		}
		super(
			wrappedCallback as (
				resolve: (value: T | PromiseLike<T>) => void,
				reject: (reason?: unknown) => void
			) => void
		)
	}

	override catch<TResult = never>(
		...args: Parameters<Promise<T>['catch']>
	): Promise<T | TResult> {
		const data = super.catch(...args) as Promise<T | TResult>
		return data
	}
}
